// The WGSL helpers that replace a GLSL builtin the port has no twin for.
//
// A twin is a hand-written port, so nothing is shared for its own sake. What
// stands here is shared because the LANGUAGE forces it: GLSL has a builtin
// that WGSL does not, and one port of it must serve every twin that called
// the builtin.
//
// GLSL has `mod(x, y)`. WGSL has no such builtin, and its `%` keeps the sign
// of the DIVIDEND: `-1.0 % 4.0` answers -1.0 where GLSL's `mod` answers 3.0.
// All three `mod()` calls of the client pass a negative operand: the segment
// batch takes the dash phase of a point BEFORE the start of its line, the
// circle batch takes the angle of a point CLOCKWISE of the arc start, and a
// terrain look takes a world coordinate behind the origin. So every one of
// them takes `glMod` instead. `mod` is a WGSL reserved word, so it can never
// be the name of the twin.
//
// The module is shared on purpose. The batch twins of the sprite passes and
// the terrain-style twins of the world passes both need the function, and one
// copy keeps the two from drifting apart.

/**
 * The GLSL `mod(x, y)` as a WGSL function.
 *
 * A twin that calls it concatenates this text in front of its own body.
 */
export const GLMOD_WGSL = `
fn glMod(x: f32, y: f32) -> f32 { return x - y * floor(x / y); }
`;
